import { Box, Link } from '@mui/material'
import { type GridColDef } from '@mui/x-data-grid-pro'
import { type SortIndexField } from '__generated__/graphql'
import { type RosterCandidateTableRowModel } from 'client/candidate-table-temp/hooks/useRosterSearchWithFilters'
import CandidateAvatar from 'recruiter/components/CandidateAvatar'
import { getPreferredName } from 'shared/utils'
import { useCandidateSqlSearch } from 'client/candidate-table-temp/hooks/useCandidateSqlSearch'
import { NameColumnHeader } from 'client/candidate-table-temp/components/RosterCandidatesTable/NameColumnHeader'

type RosterCandidateTableColumnDefinition =
    GridColDef<RosterCandidateTableRowModel> & {
        sortIndexField?: SortIndexField
    }

export default function useClientPortalColumnDefs(): Record<
    string,
    RosterCandidateTableColumnDefinition
> {
    const { setRosterCandidateId } = useCandidateSqlSearch()

    return {
        name: {
            field: 'name',
            headerName: 'Name',
            editable: false,
            sortable: false,
            width: 220,
            renderCell: ({ row }) => (
                <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{
                        height: '100%',
                        width: '100%',
                    }}
                >
                    <CandidateAvatar
                        firstName={row.nickname ?? row.firstName}
                        lastName={row.lastName}
                        profileImage={
                            row.profileImageKey ||
                            row.internalProfileImageKey ||
                            ''
                        }
                        sx={{
                            height: '38px',
                            width: '38px',
                            flexShrink: 0,
                            fontSize: '15px',
                        }}
                    />
                    <Box
                        display="flex"
                        flexDirection="column"
                        gap={0.5}
                        sx={{
                            height: '100%',
                            justifyContent: 'center',
                            flex: 1,
                        }}
                    >
                        <Link
                            onClick={() => {
                                setRosterCandidateId(
                                    row.rosterCandidateId || undefined
                                )
                            }}
                            sx={{
                                textDecoration: 'none',
                                lineHeight: 1.2,
                                display: 'block',
                                flexShrink: 0,
                                cursor: 'pointer',
                            }}
                        >
                            {getPreferredName(row)} {row.lastName}
                        </Link>
                    </Box>
                </Box>
            ),
            renderHeader: () => <NameColumnHeader />,
        },
    }
}
